import {VisitTimer} from "./visittimer.js";

'use strict';

/**
 * Exposes the 'start' method which is used to begin tracking the visit length.
 */
real.visit = (function (real) {
    const visitEndpoint = document.documentElement.getAttribute('data-base-uri') + '/api/pagevisit';

    /**
     * Helper for posting the current length of the visit.
     *
     * @param {string} pageId
     * @param {string} visitId
     * @param {number} millis
     */
    const sendPageVisit = (pageId, visitId, millis) => {
        if (real.realtime.getActiveConnection().getStatus() === 'offline') {
            // Just skip updates when we're offline.
            return;
        }
        const payload = {
            page_id: pageId,
            visit_id: visitId,
            visit_length: Math.floor(millis/1000),
        }

        // Fire and forget
        real.ajax.json(visitEndpoint, {
            type: 'POST',
            data: JSON.stringify(payload),
            error: () => {},
        });
    };

    // The timer will run for maximum millis of
    //    base*(factor^maximum-1)
    /** @type {import("./visittimer.js").VisitTimer} */
    const timer = new VisitTimer(60*1000, 2, 6);

    // Stop visit timer when switching tabs
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === "visible") {
            timer.continue();
        } else {
            timer.pause();
        }
    });

    // Stop visit timer when switching apps (also stops when
    // user focuses address bar, or devtools).
    window.addEventListener('focus', () => {
        timer.continue();
    });
    window.addEventListener('blur', () => {
        timer.pause();
    });

    // Expose the object
    return {
        /**
         * Starts a fresh page visit timer.
         *
         * @param {string} pageId
         * @param {string} visitId
         */
        start: (pageId, visitId) => {
            timer.clear();
            timer.addCallback((millis) => sendPageVisit(pageId, visitId, millis));
            timer.next();
            // Register the current visit ID to DOM so ajax.js can attach it to all AJAX requests.
            real.dom.$body.data('visit-id', visitId);
        },

        /**
         * @returns {number} Milliseconds the timer was executing in total.
         */
        stop: () => timer.halt(),

        /**
         * @type {ExponentialTimer} For debugging
         */
        timer,
    };
})(real);
